import {
  APISurveyAttributes,
  SurveyFilterSetupAttributes,
  SurveyQuestionType,
  SurveyResultFilteringType,
  UnpersistedEntity,
} from '@ardoq/api-types';
import { uniqueId } from 'lodash';
import { DEFAULT_ADVANCED_SEARCH_LIMITER } from './consts';

export const emptyFilterSetup: SurveyFilterSetupAttributes = {
  properties: {},
  enabled: false,
  type: SurveyResultFilteringType.HIERARCHY,
  label: 'Select to filter:',
};

export const emptySurvey = (): UnpersistedEntity<APISurveyAttributes> => ({
  name: '',
  description: '',
  published: false,
  contactEmail: undefined,
  workspace: null,
  componentTypeName: '',
  componentSearch: DEFAULT_ADVANCED_SEARCH_LIMITER,
  componentTypeIds: null,
  responseFeedbackOnSurveySubmit: null,
  customHeaderFields: [
    {
      name: 'lastUpdated',
      label: 'Last updated',
    },
    {
      name: 'surveyComponentStatus',
      label: 'Task Status',
    },
  ],
  questions: [
    {
      type: SurveyQuestionType.ATTRIBUTE,
      label: 'Name?',
      description: '',
      properties: { attributeName: 'name' },
      readonly: false,
      key: uniqueId(),
    },
  ],
  allowComponentCreation: true,
  allowComponentDeletion: false,
  misc: {
    generalInformationSectionStatus: 'initial',
    defineTheDataSectionStatus: 'initial',
    questionsSectionStatus: 'initial',
    feedbackMessageSectionStatus: 'initial',
    landingPageSectionStatus: 'initial',
    resultsDisplaySectionStatus: 'initial',
    ardoqDiscoverSectionStatus: 'initial',
    changeApprovalSectionStatus: 'initial',
    permissionsAndVisibilitySectionStatus: 'initial',
    overviewButtonText: '',
    newCompButtonText: '',
    disableLandingPage: false,
  },
  filterSetup: emptyFilterSetup,
  responseFeedbackMessage: '',
  surveyNotificationsEnabled: null,
});
